import { stringify } from 'qs';
import request from '../utils/request';
import local from '../utils/local';

export async function getList(params) {
  return request(`/voucher/codes?${stringify(params)}`);
}

export async function get(id, params = {}) {
  return request(`/voucher/codes/${id}`, { params });
}

export async function create(body) {
  return request(`/voucher/import-codes`, {
    method: 'POST',
    body,
  });
}

export async function createByFile(body, url) {
  const formData = new FormData()
  formData.append("file", body.file)
  formData.append("partner_id", body.partner_id)
  formData.append("note", body.note || "")
  return request(url, {
    method: 'POST',
    headers: {
      // "Content-Type": "multipart/form-data",
      "Accept": body.file.type,
      'X-Access-Token': local.get('token')
    },
    body: formData,
  });
}

export async function update(id, body) {
  return request(`/voucher/codes/${id}`, {
    method: 'POST',
    body,
  });
}